export enum CategoryType {
  STANDARD = 1,
  CYCLING = 2
}

export enum Gender {
  MALE = 1,
  FEMALE = 2
}

export class Category {
  id?: number;
  organiserId?: number;
  name?: string;
  categoryType?: CategoryType;
  items?: CategoryItem[];
  raceCount?: number
}

export class CategoryItem {
  id?: number;
  categoryId?: number;
  code?: string;
  name?: string;
  gender?: Gender;
  // start of interval
  ageFrom?: number;
  // end of interval
  ageTo?: number;
  // is this category item used
  active?: boolean;

  public static groupAndSortCategoryItems(categoryItems: CategoryItem[]): CategoryItem[] {
    categoryItems.sort((a, b) => {
      if (a.ageFrom === b.ageFrom) {
        if (a.gender === Gender.MALE && b.gender === Gender.FEMALE) {
          return -1;
        } else if (a.gender === Gender.FEMALE && b.gender === Gender.MALE) {
          return 1;
        }
        return 0;
      }
      return (a.ageFrom || 0) - (b.ageFrom || 0);
    });
    return categoryItems;
  }
}
